import { render } from "./IndexList.vue?vue&type=template&id=d882415a&ts=true"
import script from "./IndexList.vue?vue&type=script&lang=ts"
export * from "./IndexList.vue?vue&type=script&lang=ts"

import "./IndexList.vue?vue&type=style&index=0&id=d882415a&lang=scss"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__